import {
	createStyles,
	IconButton,
	makeStyles,
	TextField,
	Theme,
} from '@material-ui/core'
import style from '@root-gipro/modules/AdminPanel/styles/adminPanel.module.scss'
import { IState } from '@root-gipro/store/interfaces'
import React, { ChangeEvent, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AdminObjectsAnalogTable
	from '@root-gipro/modules/AdminPanel/components/AdminObjectsAnalog/components/AdminObjectsAnalogTable/AdminObjectsAnalogTable'
import {
  getAdminObjectsAnalog,
  setAdminAddModalOA
} from '@root-gipro/modules/AdminPanel/store/actions/actionAdminObjectsAnalog'
import { getObjectsAnalogSelector } from '@root-gipro/modules/AdminPanel/selectors/selectors'
import AdminModalDeleteOA
	from '@root-gipro/modules/AdminPanel/components/AdminObjectsAnalog/components/modals/AdminModalDeleteOA/AdminModalDeleteOA'
import Add from '@material-ui/icons/Add'
import AdminAddObjectAnalog
  from '@root-gipro/modules/AdminPanel/components/AdminObjectsAnalog/components/modals/AdminAddObjectAnalog/AdminAddObjectAnalog'

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			borderRadius: 8,
		},
		textField: {
			'& .MuiInputBase-root': {
				width: '300px',
			},
		},
	})
);

const AdminObjectsAnalog = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const {
		objectsAnalogCommon
	} = useSelector((state: IState) => state.adminPanel);

	const [sort, setSort] = useState<string>('id DESC');
	const [searchInputValue, setSearchInputValue] = useState<string>('');
	const [totalAmountOA, setTotalAmountOA] = useState(0);

	const objectsAnalogMemo = useMemo(() => {
		return getObjectsAnalogSelector(objectsAnalogCommon.objectsAnalog, sort, searchInputValue);
	}, [sort, searchInputValue, objectsAnalogCommon.objectsAnalog]);

	const onChangeSort = (newSort: string) => {
		setSort(newSort);
	}
	
	const onChangeSearchInputHandler = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchInputValue(e.target.value);
	};
  
  const onClickAddOAHandler = () => {
    dispatch(setAdminAddModalOA({ isOpen: true }));
  };

	useEffect(() => {
		setTotalAmountOA(objectsAnalogCommon.objectsAnalog?.length ?? 0);
	}, [objectsAnalogCommon.objectsAnalog])

	useEffect(() => {
		dispatch(getAdminObjectsAnalog({}));
	}, [])
	
	return (
		<div className='adminPanel-container'>
			<div className={style.adminPanel__header}>
				<div className={style.adminPanel__headerLeft}>
					<IconButton>
						{<Add onClick={onClickAddOAHandler} />}
					</IconButton>
					
					<TextField
						classes={{ root: classes.textField }}
						variant='outlined'
						placeholder='Номер, наименование ОА или ТХ'
						value={searchInputValue}
						onChange={onChangeSearchInputHandler}
					/>
				</div>
				
				<div className={style.adminPanel__headerAmount}>
					<p>
						Всего объектов-аналогов:&nbsp;
						<span className={style.boldText}>
							{totalAmountOA}
						</span>
					</p>
				</div>
			</div>

			{/* Таблица с объектами аналогами */}
			
			<AdminObjectsAnalogTable
				objectsAnalog={objectsAnalogMemo}
				loadingObjectsAnalogPage={objectsAnalogCommon.isObjectsAnalogLoading}
				sort={sort}
				onChangeSort={onChangeSort}
			/>

			<AdminModalDeleteOA />
      
      <AdminAddObjectAnalog />
    </div>
	)
}

export default AdminObjectsAnalog;
